import { DealerOffersServingService } from '@wix/ambassador-dealer-offers-serving-service/http';
import {
  BANNER_OFFER_REAL_ESTATE_ID,
  CARDS_OFFER_REAL_ESTATE_ID,
} from '../config';

export class DealerService {
  private readonly dealerApi: ReturnType<typeof DealerOffersServingService>;
  constructor(private readonly baseUrl: string, private readonly instance) {
    this.dealerApi = DealerOffersServingService(this.baseUrl, {
      useRedAxios: true,
    });
  }

  public async getBanner() {
    return this.DealerOffersServing.listOffers({
      realEstateId: BANNER_OFFER_REAL_ESTATE_ID,
    });
  }

  public async getCards() {
    return this.DealerOffersServing.listOffers({
      realEstateId: CARDS_OFFER_REAL_ESTATE_ID,
    });
  }

  get DealerOffersServing() {
    return this.dealerApi.DealerOffersServing()({
      Authorization: this.instance,
    });
  }
}
